/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Ogdescription1Inputs */

const id_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games Store gratis dan sumber terbuka dengan informasi game lengkap, pelacakan penjualan, dan banyak lagi. Berbasis komunitas dan terus diperbarui.`)
};

const ms_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalan data Epic Games Store percuma dan sumber terbuka dengan maklumat permainan yang lengkap, penjejakan jualan, dan banyak lagi. Didorong komuniti dan sentiasa dikemas kini.`)
};

const da_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En gratis og open-source Epic Games Store database med omfattende spilinformation, salgssporing og mere. Fællesskabsdrevet og konstant opdateret.`)
};

const de_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine kostenlose und quelloffene Epic Games Store-Datenbank mit umfassenden Spielinformationen, Verkaufsverfolgung und mehr. Community-getrieben und ständig aktualisiert.`)
};

const en_us2_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free and open-source Epic Games Store database with comprehensive game information, sales tracking, and more. Community-driven and constantly updated.`)
};

const es_es2_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una base de datos de la Epic Games Store gratuita y de código abierto con información completa de juegos, seguimiento de ventas y más. Impulsada por la comunidad y actualizada constantemente.`)
};

const es_mx2_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una base de datos de la Epic Games Store gratuita y de código abierto con información completa de juegos, seguimiento de ventas y más. Impulsada por la comunidad y actualizada constantemente.`)
};

const fil_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang libre at open-source na Epic Games Store database na may komprehensibong impormasyon ng laro, pagsubaybay sa benta, at marami pa. Pinapatakbo ng komunidad at palaging ina-update.`)
};

const fr_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une base de données gratuite et open-source de l'Epic Games Store avec des informations complètes sur les jeux, le suivi des ventes et bien plus. Pilotée par la communauté et constamment mise à jour.`)
};

const it_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un database gratuito e open source dell'Epic Games Store con informazioni complete sui giochi, monitoraggio delle vendite e altro ancora. Guidato dalla community e costantemente aggiornato.`)
};

const hu_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy ingyenes és nyílt forráskódú Epic Games Store adatbázis átfogó játékinformációkkal, eladáskövetéssel és többel. Közösség által működtetett és folyamatosan frissített.`)
};

const nl_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gratis en open-source Epic Games Store database met uitgebreide game-informatie, verkoopregistratie en meer. Community-gestuurd en voortdurend bijgewerkt.`)
};

const no_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En gratis og åpen kildekode Epic Games Store-database med omfattende spillinformasjon, salgssporing og mer. Fellesskapsdrevet og stadig oppdatert.`)
};

const pl_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowa i otwarta baza danych Epic Games Store z kompleksowymi informacjami o grach, śledzeniem promocji i nie tylko. Napędzana przez społeczność i stale aktualizowana.`)
};

const pt_br2_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma base de dados gratuita e open-source da Epic Games Store com informações completas de jogos, rastreamento de promoções e muito mais. Feita pela comunidade e atualizada constantemente.`)
};

const pt_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma base de dados gratuita e de código aberto da Epic Games Store com informações abrangentes sobre jogos, acompanhamento de vendas e muito mais. Orientada pela comunidade e constantemente atualizada.`)
};

const ro_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O bază de date gratuită și open-source a Epic Games Store cu informații complete despre jocuri, urmărirea vânzărilor și multe altele. Condusă de comunitate și actualizată constant.`)
};

const fi_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen ja avoimen lähdekoodin Epic Games Store -tietokanta kattavilla pelitiedoilla, myynnin seurannalla ja muulla. Yhteisön ylläpitämä ja jatkuvasti päivitetty.`)
};

const sv_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En gratis och öppen källkod-databas för Epic Games Store med omfattande spelinformation, försäljningsspårning och mer. Community-drivet och ständigt uppdaterat.`)
};

const vi_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở dữ liệu Epic Games Store miễn phí và mã nguồn mở với thông tin game toàn diện, theo dõi doanh số và hơn thế nữa. Được cộng đồng điều hành và cập nhật liên tục.`)
};

const tr_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsamlı oyun bilgileri, satış takibi ve daha fazlasıyla ücretsiz ve açık kaynaklı bir Epic Games Store veritabanı. Topluluk odaklı ve sürekli güncellenir.`)
};

const cs_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezplatná a otevřená databáze Epic Games Store s komplexními informacemi o hrách, sledováním prodejů a dalšími funkcemi. Řízeno komunitou a neustále aktualizováno.`)
};

const bg_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатна база данни с отворен код на Epic Games Store с изчерпателна информация за игри, проследяване на продажби и още. Ръководена от общността и постоянно актуализирана.`)
};

const ru_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатная база данных Epic Games Store с открытым исходным кодом, содержащая подробную информацию об играх, отслеживание распродаж, акций и многое другое. Проект развивается силами сообщества и постоянно обновляется.`)
};

const uk_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовна база даних Epic Games Store з відкритим кодом: повна інформація про ігри, відстеження продажів тощо. Створена спільнотою та постійно оновлюється.`)
};

const ar_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة بيانات مجانية ومفتوحة المصدر لـ Epic Games Store تحتوي على معلومات شاملة عن الألعاب وتتبع المبيعات والمزيد. مدفوعة من المجتمع ويتم تحديثها باستمرار.`)
};

const hi_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक मुफ़्त और ओपन-सोर्स Epic Games Store डेटाबेस जिसमें व्यापक गेम जानकारी, बिक्री ट्रैकिंग और बहुत कुछ है। सामुदायिक संचालित और लगातार अपडेट किया जाता है।`)
};

const th_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานข้อมูล Epic Games Store ฟรีและโอเพนซอร์ส พร้อมข้อมูลเกมที่ครอบคลุม การติดตามการขาย และอื่น ๆ ขับเคลื่อนโดยชุมชนและอัปเดตอยู่เสมอ`)
};

const ja_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオープンソース Epic Games Store データベース。包括的なゲーム情報、販売追跡などを提供。コミュニティ主導で常に更新。`)
};

const zh_cn2_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个免费且开源的Epic游戏商城数据库，提供全面的游戏信息、价格追踪等功能。由社区驱动并保持实时更新。`)
};

const zh_hant1_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一個免費且開源的Epic遊戲商城資料庫，提供全面的遊戲資訊、價格追蹤等功能。由社群驅動並保持即時更新。`)
};

const ko_meta_ogdescription1 = /** @type {(inputs: Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 오픈소스 Epic Games Store 데이터베이스로, 종합적인 게임 정보, 판매 추적 등을 제공합니다. 커뮤니티 기반으로 지속적으로 업데이트됩니다.`)
};

/**
* | output |
* | --- |
* | "A free and open-source Epic Games Store database with comprehensive game information, sales tracking, and more. Community-driven and constantly updated." |
*
* @param {Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const meta_ogdescription1 = /** @type {((inputs?: Meta_Ogdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Ogdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_meta_ogdescription1(inputs)
	if (locale === "ms") return ms_meta_ogdescription1(inputs)
	if (locale === "da") return da_meta_ogdescription1(inputs)
	if (locale === "de") return de_meta_ogdescription1(inputs)
	if (locale === "en-US") return en_us2_meta_ogdescription1(inputs)
	if (locale === "es-ES") return es_es2_meta_ogdescription1(inputs)
	if (locale === "es-MX") return es_mx2_meta_ogdescription1(inputs)
	if (locale === "fil") return fil_meta_ogdescription1(inputs)
	if (locale === "fr") return fr_meta_ogdescription1(inputs)
	if (locale === "it") return it_meta_ogdescription1(inputs)
	if (locale === "hu") return hu_meta_ogdescription1(inputs)
	if (locale === "nl") return nl_meta_ogdescription1(inputs)
	if (locale === "no") return no_meta_ogdescription1(inputs)
	if (locale === "pl") return pl_meta_ogdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_meta_ogdescription1(inputs)
	if (locale === "pt") return pt_meta_ogdescription1(inputs)
	if (locale === "ro") return ro_meta_ogdescription1(inputs)
	if (locale === "fi") return fi_meta_ogdescription1(inputs)
	if (locale === "sv") return sv_meta_ogdescription1(inputs)
	if (locale === "vi") return vi_meta_ogdescription1(inputs)
	if (locale === "tr") return tr_meta_ogdescription1(inputs)
	if (locale === "cs") return cs_meta_ogdescription1(inputs)
	if (locale === "bg") return bg_meta_ogdescription1(inputs)
	if (locale === "ru") return ru_meta_ogdescription1(inputs)
	if (locale === "uk") return uk_meta_ogdescription1(inputs)
	if (locale === "ar") return ar_meta_ogdescription1(inputs)
	if (locale === "hi") return hi_meta_ogdescription1(inputs)
	if (locale === "th") return th_meta_ogdescription1(inputs)
	if (locale === "ja") return ja_meta_ogdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_meta_ogdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_meta_ogdescription1(inputs)
	return ko_meta_ogdescription1(inputs)
});
export { meta_ogdescription1 as "meta.ogDescription" }